import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { RingBuilderMountSwitchResult } from '@/graphql/api'

export const useRingBuilderGranderResultStore = defineStore(
    'ring-builder-grande-result',
    () => {
        const hasSwitchedToGrande = ref(false)
        /** New object on every switch so watchers fire even for repeats. */
        const lastMountSwitch = ref<{
            result: RingBuilderMountSwitchResult
        } | null>(null)

        return { hasSwitchedToGrande, lastMountSwitch }
    }
)
